__turbopack_context__.v({
  "arrowLeft": "Button-module-scss-module__jNUHUq__arrowLeft",
  "arrowRight": "Button-module-scss-module__jNUHUq__arrowRight",
  "blackText": "Button-module-scss-module__jNUHUq__blackText",
  "btn": "Button-module-scss-module__jNUHUq__btn",
  "btnNoBorder": "Button-module-scss-module__jNUHUq__btnNoBorder",
});
